import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

const logGlobalError = (errorInfo: any) => {
  Sentry.captureException(errorInfo);
  console.warn("[GlobalErrorHandler]", errorInfo);
};

export const useGlobalErrorHandler = () => {
  useEffect(() => {
    const offendingKey = "9fd7f3a3-9259-43dc-b758-3a78d56eef25_EXTERNAL"; // Update if your Flowise key changes

    const handleQuotaErrorAndRedirect = (reason: any) => {
      if (
        (reason && reason.name === "QuotaExceededError") ||
        (typeof reason === "string" && reason.includes("QuotaExceededError"))
      ) {
        try {
          localStorage.removeItem(offendingKey);
        } catch (e) {
          localStorage.clear();
        }
        window.location.href = "/somethingWentWrong";
        return true;
      }
      // For all other errors, just log, do not redirect
      return false;
    };

    const handleWindowError = (
      message: string | Event,
      source?: string,
      lineno?: number,
      colno?: number,
      error?: Error
    ) => {
      logGlobalError({
        type: "window.onerror",
        message,
        source,
        lineno,
        colno,
        error,
      });
      // Only redirect for QuotaExceededError
      handleQuotaErrorAndRedirect(error || message);
      return false;
    };

    const handleGlobalRejection = (event: PromiseRejectionEvent) => {
      logGlobalError({
        type: "unhandledrejection",
        reason: event.reason,
        event,
      });
      // Only redirect for QuotaExceededError
      handleQuotaErrorAndRedirect(event.reason);
    };

    window.onerror = handleWindowError;
    window.addEventListener("unhandledrejection", handleGlobalRejection);

    return () => {
      window.onerror = null;
      window.removeEventListener("unhandledrejection", handleGlobalRejection);
    };
  }, []);
};
